export default __webpack_public_path__ + "images/4c997cc9d757dc6521b704eda224b585.png";